import { lazy, Suspense } from "react";
import { Loader2 } from "lucide-react";
import IosPaymentRedirect from "../../components/IosPaymentRedirect";
import { shouldHideSubscriptionPurchase } from "../../utils/platform";

const PaymentPage = lazy(() => import("./payment"));

/**
 * iOS: redirect — payment methods page is never rendered.
 */
export default function PaymentRouteGate() {
  if (shouldHideSubscriptionPurchase()) {
    return <IosPaymentRedirect fallback="/home" />;
  }

  return (
    <Suspense
      fallback={
        <div className="flex min-h-screen items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        </div>
      }
    >
      <PaymentPage />
    </Suspense>
  );
}
